import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const YesNoDialog = ({
  openDialog,
  message,
  handleCloseDialog,
  handleYes,
  title = 'Alert!',
  showCloseButton = false
}) => {
  return (
    <div>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!showCloseButton && (
            <>
              <Button
                className="dialog-action-btn"
                onClick={handleYes}
                color="primary"
              >
                Yes
              </Button>
              <Button
                className="dialog-action-btn"
                onClick={handleCloseDialog}
                color="primary"
                autoFocus
              >
                No
              </Button>
            </>
          )}

          {showCloseButton && (
            <Button
              className="dialog-action-btn"
              onClick={handleCloseDialog}
              color="primary"
              autoFocus
            >
              Close
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

YesNoDialog.propTypes = {
  openDialog: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  message: PropTypes.string,
  title: PropTypes.string,
  handleCloseDialog: PropTypes.func,
  handleYes: PropTypes.func
};


export default YesNoDialog;
